import en_US from "../../../../node_modules/.pnpm/@uppy_locales@4.5.2/node_modules/@uppy/locales/lib/en_US.js";
const fileManagerRestrictionLocale = {
  maxFileSize: "Maximum file size",
  maxFiles: "Maximum number of files",
  maxTotalSize: "Maximum total size",
  allowedTypes: "Allowed file types",
  description: "Drag and drop files here or click to upload",
  or: "or",
  buttonText: "Select Files",
  emptyText: "No Files",
  statusText: {
    init: "Init",
    uploading: "Uploading",
    success: "Success",
    failed: "Failed",
    cancelled: "Cancelled",
    paused: "Paused",
    saved: "Saved"
  },
  uppyLocale: en_US
};
export {
  fileManagerRestrictionLocale
};
//# sourceMappingURL=en_US.js.map
